import { NSARouterMakerResult } from "namirasoft-account-react";
import { FieldEntities } from "../FieldEntities";
import { FieldLayout } from "../FieldLayout";
import { FieldProps } from "../FieldProps";

interface FieldListPageProps extends NSARouterMakerResult, FieldProps { }

export default function FieldListPage(props: FieldListPageProps)
{
	return (
		<FieldLayout {...props}
			action={{
				description: "This section displays all fields you have created with their basic information."
			}}
			pages={{
				entity: FieldEntities.field(props),
				list: {}
			}}
		>
			<></>
		</FieldLayout>
	);
}